/**
 * Parse a date-only value that arrives from the API as a UTC midnight ISO timestamp
 * (e.g. "2026-06-01T00:00:00.000Z") into a local midnight Date.
 *
 * Without this, new Date("2026-06-01T00:00:00.000Z") in any US timezone becomes
 * 7 PM May 31 local time, so toLocaleDateString() renders the wrong day.
 *
 * Safe for both full ISO strings and bare date strings ("2026-06-01").
 */
export function parseElectionDate(value) {
  if (!value) return null;
  const str = typeof value === 'string' ? value : value.toISOString();
  return new Date(`${str.slice(0, 10)}T00:00:00`);
}
